import LienWaiverTable, { DrawGroup } from "./LienWaiverTable";
import TableSkeleton from "Components/Common/Skeleton/TableSkeleton";

interface Props {
  lienItemsData: Record<string, DrawGroup>;
  loading?: boolean;
}

export default function OwnerLienWaiversSection({
  lienItemsData,
  loading,
}: Props) {
  return (
    <>
      <div className="section-title">Lien Waiver Status</div>
      <div className="section-sub">
        Lien waivers collected for each draw period
      </div>

      <div className="card">
        <div className="card-title">
          Waiver Tracking <span className="read-only-badge">Read Only</span>
        </div>
        {loading ? (
          <TableSkeleton cols={5} rows={5} />
        ) : (
          <LienWaiverTable lienItemsData={lienItemsData} />
        )}
      </div>
    </>
  );
}
